var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import _ from 'lodash';
import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { ApplicationContext } from '../../../ApplicationContext';
import ServiceEntryStatus from '../../../data/ServiceEntryStatus';
import { Badge } from 'reactstrap';
import AssetLabelFilterItem from '../Assets/filters/AssetLabelFilterItem';
import { Link } from 'react-router-dom';
import Routes from '../../../routes/RoutesConfig';
import ServiceEntriesSignals from './signals/ServiceEntriesSignals';
/**
 *
 */
var ServiceEntryFilters = /** @class */ (function (_super) {
    __extends(ServiceEntryFilters, _super);
    /**
     *
     * @param props
     */
    function ServiceEntryFilters(props) {
        var _this = _super.call(this, props) || this;
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.onLabelFilterClick = _this.onLabelFilterClick.bind(_this);
        return _this;
    }
    /**
     *
     */
    ServiceEntryFilters.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, serviceEntryCollection = _a.serviceEntryCollection;
        var session = this.context.session;
        var activeFilters = serviceEntryCollection.filter.activeFilters;
        var statusValue = serviceEntryCollection.statusFilter.value != null ? serviceEntryCollection.statusFilter.value : '*';
        var labelsValue = serviceEntryCollection.labelsFilter.value != null && serviceEntryCollection.labelsFilter.value.length > 0 ? 'selected' : '*';
        return React.createElement("div", { className: 'service-entries-filters d-flex ' + className },
            React.createElement("div", { className: "btn-group", role: "group" },
                activeFilters.length > 0 &&
                    React.createElement("button", { className: "btn btn-white", onClick: function () {
                            serviceEntryCollection.filter.resetAllFilters();
                            _this.update();
                        } },
                        React.createElement("i", { className: activeFilters.length > 0 ? 'fe fe-x' : 'fe fe-filter' })),
                React.createElement("div", { className: "nav btn-group dropdown", role: "group" },
                    React.createElement("button", { className: 'btn btn-white dropdown-toggle' + (statusValue !== '*' ? ' active' : ''), type: "button", id: "statusFilterButton", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
                        React.createElement("div", { className: "d-none d-md-inline" },
                            React.createElement(FormattedMessage, { id: 'service.entry.status.' + (statusValue !== '*' ? ServiceEntryStatus.getKeyByValue(statusValue) : '*') })),
                        React.createElement("span", { className: "d-md-none fe fe-activity" })),
                    React.createElement("div", { className: "dropdown-menu", "aria-labelledby": "statusFilterButton" },
                        React.createElement("a", { className: "dropdown-item", href: "#", onClick: function (event) { _this.onFilterChange(event); }, "data-filter-type": "STATUS", "data-filter-value": "*" },
                            React.createElement("i", { className: "fe fe-activity mr-2 service-entry-status__icon service-entry-status--None" }),
                            React.createElement(FormattedMessage, { id: "service.entry.status.*" })),
                        React.createElement("a", { className: "dropdown-item", href: "#", onClick: function (event) { _this.onFilterChange(event); }, "data-filter-type": "STATUS", "data-filter-value": ServiceEntryStatus.Created },
                            React.createElement("i", { className: "fe fe-activity mr-2 service-entry-status__icon service-entry-status--Created" }),
                            React.createElement(FormattedMessage, { id: "service.entry.status.Created" })),
                        React.createElement("a", { className: "dropdown-item", href: "#", onClick: function (event) { _this.onFilterChange(event); }, "data-filter-type": "STATUS", "data-filter-value": ServiceEntryStatus.InProgress },
                            React.createElement("i", { className: "fe fe-activity mr-2 service-entry-status__icon service-entry-status--InProgress" }),
                            React.createElement(FormattedMessage, { id: "service.entry.status.InProgress" })))),
                React.createElement("div", { className: "nav btn-group dropdown", role: "group" },
                    React.createElement("button", { className: 'btn ml-0 btn-white dropdown-toggle' + (labelsValue !== '*' ? ' active' : ''), type: "button", id: "labelsFilterButton", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
                        React.createElement("div", { className: "d-none d-md-inline" },
                            React.createElement(FormattedMessage, { id: 'filters.labels.' + labelsValue }),
                            labelsValue !== '*' ? React.createElement(Badge, { pill: true, color: "soft-primary ml-2" }, serviceEntryCollection.labelsFilter.value.length) : null),
                        React.createElement("span", { className: "d-md-none fe fe-tag" })),
                    React.createElement("div", { className: "dropdown-menu", "aria-labelledby": "labelFilterButton" },
                        React.createElement("ul", { className: 'dropdown-label-list-service-entry' }, serviceEntryCollection.uniqueLabels.map(function (labelModel) {
                            return React.createElement(AssetLabelFilterItem, { labelModel: labelModel, key: 'lm-' + labelModel.id, labelsFilter: serviceEntryCollection.labelsFilter, onClick: _this.onLabelFilterClick });
                        })),
                        serviceEntryCollection.uniqueLabels.length > 0 && session.user && session.user.isOwner ?
                            React.createElement("hr", { className: "w-100 my-2" }) : null,
                        session.user && session.user.isOwner &&
                            React.createElement("div", { className: "d-flex justify-content-center w-100" },
                                React.createElement(Link, { to: Routes.LABELS.getPath() },
                                    React.createElement("i", { className: "fe fe-edit-2" }),
                                    " ",
                                    React.createElement(FormattedMessage, { id: "filters.labels.edit" })))))));
    };
    /**
     *
     * @param event
     */
    ServiceEntryFilters.prototype.onFilterChange = function (event) {
        event.preventDefault();
        var serviceEntryCollection = this.props.serviceEntryCollection;
        var filterType = event.target.dataset.filterType;
        var filterValue = event.target.dataset.filterValue;
        switch (filterType) {
            case 'STATUS':
                serviceEntryCollection.statusFilter.value = filterValue === '*' ? null : parseInt(filterValue);
                break;
            default:
            //none
        }
        this.update();
    };
    /**
     *
     * @param event
     */
    ServiceEntryFilters.prototype.onLabelFilterClick = function (event) {
        event.preventDefault();
        event.stopPropagation();
        var serviceEntryCollection = this.props.serviceEntryCollection;
        if (serviceEntryCollection.labelsFilter.value === null) {
            serviceEntryCollection.labelsFilter.value = [];
        }
        var value = event.currentTarget.dataset.value;
        var checked = event.currentTarget.dataset.checked === 'true';
        if (!checked) {
            serviceEntryCollection.labelsFilter.value.push(value);
        }
        else {
            _.remove(serviceEntryCollection.labelsFilter.value, function (val) { return val === value; });
        }
        this.update();
    };
    /**
     *
     */
    ServiceEntryFilters.prototype.update = function () {
        var serviceEntryCollection = this.props.serviceEntryCollection;
        serviceEntryCollection.updateFilterCache();
        serviceEntryCollection.update();
        ServiceEntriesSignals.filtersChanged.dispatch();
        ServiceEntriesSignals.zoomOut.dispatch();
        this.forceUpdate();
    };
    ServiceEntryFilters.defaultProps = {
        className: ''
    };
    ServiceEntryFilters = __decorate([
        observer
    ], ServiceEntryFilters);
    return ServiceEntryFilters;
}(React.Component));
ServiceEntryFilters.contextType = ApplicationContext;
export default ServiceEntryFilters;
